import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Button, cn } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { usePurchaseDisplay } from "./usePurchaseDisplay";

export interface PurchaseDetailsProps {
  purchase: TellescopeModelFromName<"purchases">;
  onBack: () => void;
  className?: string;
}

export const PurchaseDetails = ({ purchase, onBack, className }: PurchaseDetailsProps) => {
  const { t } = useTranslation("contacts");
  const getDisplayFields = usePurchaseDisplay();
  const { amount, date, description } = getDisplayFields(purchase);

  return (
    <div className={cn("flex flex-col gap-3 text-left", className)}>
      <Button variant="link" color="secondary" size="sm" className="h-auto self-start p-0" onClick={onBack}>
        {t("All purchases")}
      </Button>

      <div className="flex flex-col gap-1 rounded-lg border bg-background px-4 py-3">
        <p className="text-sm font-semibold text-foreground">{purchase.title}</p>
        {!!description && <p className="text-xs text-muted-foreground">{description}</p>}

        <div className="mt-2 flex items-end justify-between gap-4">
          <p className="text-sm text-foreground">{amount}</p>
          <p className="shrink-0 text-xs text-muted-foreground">{date}</p>
        </div>
      </div>
    </div>
  );
};
